"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var shapes_base_1 = require("./shapes-base");

var config_1 = require("./config");

var utils_1 = require("./utils");

exports.createSideShapes = function (plateComponents, canvas) {
  var shapes = [];
  var plate = createPlateShapes(plateComponents.elements.concat(plateComponents.additional), plateComponents.plate, canvas);
  shapes.push(plate);
  var consoleShapes = createConsoleShapes(plateComponents.elements.concat(plateComponents.additional), plateComponents.plate, canvas);
  shapes.push(consoleShapes);
  var wallShapes = createWallShapes(plateComponents.elements.concat(plateComponents.additional), plateComponents.plate, canvas);
  shapes.push(wallShapes);
  var elementShapes = createSideElementShapes(plateComponents.elements.concat(plateComponents.additional), plateComponents.plate, canvas);
  shapes.push(elementShapes);
  return shapes;
};

var createPlateShapes = function createPlateShapes(elements, plate, canvas) {
  var shapes = [];
  var backsplash = elements.find(function (e) {
    return (e.type === 'surge-edge' || e.type === 'back-splash') && !e.isLast && !e.isFirst;
  });
  var frontApron = elements.find(function (e) {
    return e.type === 'apron' && !e.isLast && !e.isFirst;
  });
  var leftApron = elements.find(function (e) {
    return e.type === 'apron' && e.isFirst;
  }); // const rightApron = elements.find(e => e.type === 'apron' && e.isFirst);

  var sideApron = elements.find(function (e) {
    return e.type === 'apron' && (e.isLast || e.isFirst);
  }); // Backsplash wall...

  if (backsplash) {
    shapes.push(shapes_base_1.createVerticalWall(backsplash.nsides.left - 1, backsplash.nsides.bottom + 1, backsplash.nsides.left - 1, backsplash.nsides.top - 2, 'right', false, backsplash.nscale.x, 11, 1.2));
  } // Plate outline


  {
    var x = plate.nsides.left;
    var y = plate.nsides.top;
    var width = plate.nscale.x;
    var height = plate.nscale.y;
    shapes.push(shapes_base_1.createRect(x, y, width, height, false, 'white', config_1.config.shapes.strokeColor, 0, false));
    shapes.push(shapes_base_1.createHorizontalWall(plate.nsides.left, plate.nsides.bottom, plate.nsides.right - 1, plate.nsides.bottom, 'top', true, true, false, plate.nscale.y, 11, 1.2));
    shapes.push(shapes_base_1.createLine(plate.nsides.left, plate.nsides.top, frontApron ? frontApron.nsides.right : plate.nsides.right, plate.nsides.top, config_1.config.shapes.strokeWidth, 'black', false));
    shapes.push(shapes_base_1.createLine(plate.nsides.left, plate.nsides.top, plate.nsides.left, plate.nsides.bottom, config_1.config.shapes.strokeWidth, 'black', false));
    shapes.push(shapes_base_1.createLine(plate.nsides.right, plate.nsides.top, plate.nsides.right, plate.nsides.bottom, config_1.config.shapes.strokeWidth, 'black', false));
    shapes.push(shapes_base_1.createLine(plate.nsides.left, plate.nsides.bottom, plate.nsides.right, plate.nsides.bottom, config_1.config.shapes.strokeWidth, 'black', false, leftApron ? true : false)); // bottom line
  } // Plate vertical right line

  {
    var x = plate.nsides.right + 2;
    var y1 = frontApron ? frontApron.nsides.bottom : plate.nsides.bottom;
    var y2 = utils_1.calculateStep(0);
    shapes.push(shapes_base_1.createLine(x, y1, x, y2));
  } // Plate horizontal measurement line

  {
    var x1 = plate.nsides.left;
    var x2 = plate.nsides.right;
    var y = utils_1.calculateStep(0, true);
    shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y));
    shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, plate.scale.x));
  } // Plate horizontal top right line

  {
    var x1 = plate.nsides.right;
    var x2 = canvas.scale.x - utils_1.calculateStep(2);
    var y = plate.nsides.top;
    shapes.push(shapes_base_1.createLine(x1, y, x2, y));
  } // Plate horizontal bottom right line

  {
    var x1 = plate.nsides.right;
    var x2 = canvas.scale.x - utils_1.calculateStep(2);
    var y = plate.nsides.bottom;
    shapes.push(shapes_base_1.createLine(x1, y, x2, y));
  } // Plate vertical measurement line

  {
    var x = canvas.scale.x - utils_1.calculateStep(2, true); // calculateStep(3, true);

    var y1 = plate.nsides.bottom;
    var y2 = plate.nsides.top;
    shapes.push(shapes_base_1.createMeasurementLine(x, y1, x, y2, true, true, 'right'));
    shapes.push(shapes_base_1.createText(x, utils_1.getCenter(y1, y2), plate.scale.y, true, 'start', 'right'));
  } // Front apron

  if (frontApron) {
    // Outline
    {
      var x = frontApron.nsides.left;
      var y = frontApron.nsides.top;
      var width = frontApron.nscale.x;
      var height = frontApron.nscale.y;
      shapes.push(shapes_base_1.createRect(x, y, width + config_1.config.shapes.strokeWidth, height, leftApron ? true : false, 'transparent', config_1.config.shapes.strokeColor, config_1.config.shapes.strokeWidth, true));
      shapes.push(shapes_base_1.createRect(x, y, width + config_1.config.shapes.strokeWidth, height, false, 'white', config_1.config.shapes.strokeColor, 0, false));
      shapes.push(shapes_base_1.createVerticalWall(frontApron.nsides.left - 1, frontApron.nsides.bottom + 1, frontApron.nsides.left - 1, frontApron.nsides.top - 2, 'right', false, frontApron.nscale.x + 2, 11, 1.2));
    } // Horizontal top line

    {
      var x1 = frontApron.nsides.right;
      var x2 = canvas.scale.x - utils_1.calculateStep(0);
      var y = frontApron.nsides.top;
      shapes.push(shapes_base_1.createLine(x1, y, x2, y));
    } // Horizontal bottom line

    {
      var x1 = frontApron.nsides.left;
      var x2 = canvas.scale.x - utils_1.calculateStep(0);
      var y = frontApron.nsides.bottom + 1;
      shapes.push(shapes_base_1.createLine(x1, y, x2, y));
    } // Vertical measurement line

    {
      var x = canvas.scale.x - utils_1.calculateStep(0, true);
      var y1 = frontApron.nsides.bottom;
      var y2 = frontApron.nsides.top;
      shapes.push(shapes_base_1.createMeasurementLine(x, y1, x, y2, true, true));
      shapes.push(shapes_base_1.createText(x, utils_1.getCenter(y1, y2), frontApron.scale.y, true));
    }
    /*
    // Vertical left line
    {
      const x = frontApron.nsides.left;
      const y1 = canvas.scale.y - calculateStep(0);
      const y2 = frontApron.nsides.bottom;
           shapes.push(createLine(x, y1, x, y2));
    }
    // Vertical right line
    {
      const x = frontApron.nsides.right + 2;
      const y1 = canvas.scale.y - calculateStep(0);
      const y2 = frontApron.nsides.bottom;
           shapes.push(createLine(x, y1, x, y2));
    }
    // Horizontal measurement line
    {
      const x1 = frontApron.nsides.left;
      const x2 = frontApron.nsides.right;
      const y = canvas.scale.y - calculateStep(0, true);
           shapes.push(createMeasurementLine(x1, y, x2, y, false, true));
      shapes.push(createText(getCenter(x1, x2), y, frontApron.scale.x));
    }
    */
  } // Side apron


  if (sideApron) {
    var x = sideApron.nsides.left;
    var y = sideApron.nsides.top;
    var width = sideApron.nscale.x;
    var height = sideApron.nscale.y;
    shapes.push(shapes_base_1.createRect(x, y, width + config_1.config.shapes.strokeWidth + 1, height + config_1.config.shapes.strokeWidth));
  }

  return shapes;
};

var createWallShapes = function createWallShapes(elements, plate, canvas) {
  var shapes = []; // Back Wall

  {
    var x = plate.nsides.left;
    var y1 = canvas.scale.y;
    var y2 = 0;
    shapes.push(shapes_base_1.createVerticalWall(x, y1, x, y2, 'left'));
  }
  return shapes;
};

var createConsoleShapes = function createConsoleShapes(elements, plate, canvas) {
  var shapes = [];
  elements.forEach(function (element, index) {
    if (element.type === 'console') {
      var x = element.nposition.x;
      var y = element.nposition.y; // shapes.push(createImage(x, y, width, height, `https://kwcws3d.blob.core.windows.net/cdn/wireframes/console.svg`));  

      if (element.fileName === 'uhalter_miranit') {
        shapes.push(shapes_base_1.createImage(x, y, element.nscale.x, element.nscale.y, "https://kwcws3d.blob.core.windows.net/cdn/wireframes/" + element.fileName + "_side.svg", true));
      } else {
        shapes.push(shapes_base_1.createRect(x, y, element.nscale.z * 0.8, element.nscale.y, false, 'transparent', config_1.config.shapes.strokeColor, config_1.config.shapes.strokeWidth / 2, true));
        shapes.push(shapes_base_1.createRect(x, y, element.nscale.x, element.nscale.z * 0.8, false, 'transparent', config_1.config.shapes.strokeColor, config_1.config.shapes.strokeWidth / 2, true));
        x = x + config_1.config.shapes.strokeWidth * 2;
        y = y + config_1.config.shapes.strokeWidth * 2;
        shapes.push(shapes_base_1.createRect(x, y, element.nscale.z * 0.8 - config_1.config.shapes.strokeWidth * 4, element.nscale.y - config_1.config.shapes.strokeWidth * 4, false, 'white', config_1.config.shapes.strokeColor, 0, false));
        shapes.push(shapes_base_1.createRect(x, y, element.nscale.x - config_1.config.shapes.strokeWidth * 4, element.nscale.z * 0.8 - config_1.config.shapes.strokeWidth * 4, false, 'white', config_1.config.shapes.strokeColor, 0, false));
      }

      if (element.elements) {
        var hasSameYPosition_1 = element.elements.every(function (e) {
          return e.position.y === element.elements[0].position.y;
        });
        element.elements.forEach(function (element, index) {
          var offset = hasSameYPosition_1 ? 0 : index; // Horizontal lines

          {
            var x1 = plate.nsides.left - utils_1.calculateStep(1 + offset, true);
            var x2 = element.nsides.right;
            shapes.push(shapes_base_1.createLine(x1, plate.nsides.top, x2, plate.nsides.top));
            shapes.push(shapes_base_1.createLine(x1, element.nposition.y, x2, element.nposition.y));
          } // Vertical measurement

          {
            var x_1 = plate.nsides.left - utils_1.calculateStep(1 + offset);
            var y1 = element.nposition.y;
            var y2 = plate.nsides.top;
            var space = element.position.y - plate.sides.top;
            shapes.push(shapes_base_1.createMeasurementLine(x_1, y1, x_1, y2, true, space < 60));
            shapes.push(shapes_base_1.createText(x_1, utils_1.getCenter(y1, y2), space, true));
          }
        });
      }
    }
  });
  return shapes;
};

var createSideElementShapes = function createSideElementShapes(elements, plate, canvas) {
  var shapes = [];
  elements.forEach(function (element, index) {
    // Trough
    if (element.type === 'trough') {
      // Outline
      {
        var x = element.nsides.left;
        var y = plate.nsides.top; // element.nsides.top;

        var width = element.nscale.x;
        var height = element.nscale.y; // The thickness of the trough material has to be accounted for in positioning of the image...

        if (element.subType !== 'backwall') {
          x = x - plate.nscale.y / 2;
          width = width + plate.nscale.y;
        }

        shapes.push(shapes_base_1.createRect(x, plate.nsides.top, width, plate.nscale.y, false, 'white', config_1.config.shapes.strokeColor, 0, false));
        shapes.push(shapes_base_1.createImage(x, y, width, height, "https://kwcws3d.blob.core.windows.net/cdn/wireframes/" + element.fileName + "_side.svg", true));
      } // Drain vertical line

      {
        var x = element.nposition.x;
        var y1 = canvas.scale.y - utils_1.calculateStep(0);
        var y2 = element.nsides.bottom;
        shapes.push(shapes_base_1.createLine(x, y1, x, y2));
      } // Drain measurement

      {
        var y = canvas.scale.y - utils_1.calculateStep(0, true);
        var x1 = plate.nsides.left;
        var x2 = element.nposition.x;
        shapes.push(shapes_base_1.createMeasurementLine(x1, y, x2, y));
        shapes.push(shapes_base_1.createText(utils_1.getCenter(x1, x2), y, element.position.x));
      }
    } // Cutout

    /*
    if (element.type === 'cut-out-hole') {
      const x = element.nsides.left;
      const y = element.nsides.top;
      const width = element.nscale.x;
      const height = element.nscale.y;
           shapes.push(createRect(x, y, width, height + config.shapes.strokeWidth, true));
    }
    */
    // Surge-edge


    if (element.type === 'surge-edge' || element.type === 'back-splash') {
      //  && element.nsides.left === plate.nsides.left
      // Shape
      {
        var x = element.nsides.left;
        var y = element.nsides.top;
        var width = element.nscale.x;
        var height = element.nscale.y;
        shapes.push(shapes_base_1.createRect(x - 1, y - 3, width + 1, height + 4));
      } // Horizontal top/bottom lines

      {
        var x1 = utils_1.calculateStep(1);
        var x2 = element.nsides.left;
        shapes.push(shapes_base_1.createLine(x1, element.nsides.top - 3, x2, element.nsides.top - 3));
        shapes.push(shapes_base_1.createLine(x1, element.nsides.bottom, x2, element.nsides.bottom));
      } // Vertical measurement line

      {
        var x = utils_1.calculateStep(1, true);
        var y1 = element.nsides.bottom;
        var y2 = element.nsides.top - 3;
        shapes.push(shapes_base_1.createMeasurementLine(x, y1, x, y2, true, true, 'right'));
        shapes.push(shapes_base_1.createText(x, utils_1.getCenter(y1, y2), element.scale.y, true, 'start', 'right'));
      }
    }

    if (typeof element.elements !== 'undefined') {
      shapes.push(createSideElementShapes(element.elements, plate, canvas));
    }
  });
  return shapes;
};